import React, { useState, useEffect } from 'react';
import Container from './Container';

/**
 * Header component with sticky navigation
 * @returns {React.ReactElement} Header component
 */
const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'Packages', href: '/service-packages' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'About', href: '/about' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Contact', href: '/contact' },
    { name: 'Clients', href: '/client' }, 
  ];

  return (
    <header 
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-brand-black/90 backdrop-blur-sm supports-[backdrop-filter]:backdrop-blur-sm shadow-lg' 
          : 'md:bg-transparent bg-brand-black/80'
      }`}
    >
      <Container className="flex items-center justify-between py-2 md:py-4 lg:py-6">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img 
            src="/assets/logo/logo-lsas-full.svg" 
            alt="Lone Star Aerial Solutions" 
            className="h-16 md:h-24 lg:h-32 w-auto"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className={`text-white hover:text-brand-blue-600 transition-colors font-medium ${
                link.name === 'Clients' 
                  ? 'relative after:content-["🔐"] after:ml-1 after:text-xs after:opacity-70' 
                  : ''
              }`}
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          type="button"
          className="md:hidden text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </Container>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-brand-black/90 backdrop-blur-sm supports-[backdrop-filter]:backdrop-blur-sm">
          <Container className="py-4">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className={`text-white hover:text-brand-blue-600 transition-colors font-medium py-2 ${
                    link.name === 'Clients' 
                      ? 'relative after:content-["🔐"] after:ml-1 after:text-xs after:opacity-70' 
                      : ''
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </Container>
        </div>
      )}
    </header>
  );
};

export default Header;
